import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component
export default class Combobox extends Vue {
	@Prop() public items!: Array<{ id: string, name: string, displayName: string }>;

	@Emit('combobox-select-change')
	public change(id: string | null) { }

	private selectChange(event: Event): void {
		const selectElement: HTMLSelectElement = event.target as HTMLSelectElement;
		const optionElement = selectElement.selectedOptions[0] as HTMLOptionElement;
		const id: string | null = optionElement.getAttribute('id');
		this.change(id);
	}
}
